import { format } from '@react-input/mask';
import { PHONE_MASK_CONFIG } from './constants';
import { differenceInYears, parseISO } from 'date-fns';
import { User } from '@/services/auth-service';

export function formatPhoneNumber(phoneNumber: string | null | undefined): string {
  if (!phoneNumber) return '';

  return format(phoneNumber, PHONE_MASK_CONFIG);
}

export function getAge(dateOfBirth: string | null | undefined): number | null {
  if (!dateOfBirth) return null;

  const birthDate = parseISO(dateOfBirth);

  return isNaN(birthDate.getTime()) ? null : differenceInYears(new Date(), birthDate);
}

type KebabToCamelCase<S extends string> = S extends `${infer Head}-${infer Tail}`
  ? `${Head}${Capitalize<KebabToCamelCase<Tail>>}`
  : S;

export function kebabToCamelCase<S extends string>(str: S): KebabToCamelCase<S> {
  return str.replace(/-([a-z])/g, (_, c) => c.toUpperCase()) as KebabToCamelCase<S>;
}

export function createEditUrl(url: string, editMode?: string | null) {
  return `${url}${editMode ? `?editMode=${editMode}` : ''}`;
}

export function downloadFile(data: Blob, fileName: string) {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
}

interface FormatNameProps {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
}

export function formatName({ firstName, middleName, lastName }: FormatNameProps): string {
  return [firstName, middleName, lastName].filter((name) => Boolean(name && name.trim())).join(' ');
}

export function caseInsensitiveCompare(right: string | undefined, left: string | undefined) {
  return right?.localeCompare(left ?? '', undefined, { sensitivity: 'accent' }) === 0;
}

interface StateProps {
  name: string;
  abbreviation: string;
}
export function formatState(state: StateProps): string {
  return `${state.name} (${state.abbreviation})`;
}

export function isUserLoggedIn(user?: User): user is User {
  return !!user && user.isPreTfa !== 'true';
}
